import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DefaultAvatar } from '../model/default-avatar';
import { DataService } from '../services/api/data.service';
import { SessionService } from '../services/session/session.service';

@Component({
  selector: 'app-change-avatar-dialog',
  templateUrl: './change-avatar-dialog.component.html'
})
export class ChangeAvatarDialogComponent {
  private firstLoad = true;
  private visibleValue: boolean;
  @Input()
  public get visible(): boolean {
    return this.visibleValue;
  }
  public set visible(value: boolean) {
    if (this.visibleValue !== value) {
      this.visibleValue = value;
      this.visibleChange.emit(value);
    }
  }
  @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private avatarValue: string;
  @Input()
  public get avatar(): string {
    return this.avatarValue;
  }
  public set avatar(value: string) {
    if (this.avatarValue !== value) {
      this.avatarValue = value;
      if (this.firstLoad) {
        if (this.avatarValue !== DefaultAvatar.imgFemaleAvatar && this.avatarValue !== DefaultAvatar.imgMaleAvatar) {
          this.firstLoad = false;
        }
      } else {
        this.avatarChanged.emit(value);
      }
    }
  }
  @Output() public avatarChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private dataService: DataService, private sessionService: SessionService) {}

  public onAvatarChanged(formData: any): void {
    if (this.sessionService.browser.isHybridApp) {
    }
    if (Object.keys(formData).length !== 0) {
      return;
    }
    this.dataService.Users_CurrentImage(formData).subscribe(
      (data: any): void => {
        if (!data) {
          this.avatar = '';
          this.visible = false;
        } else {
          this.avatar = data;
          this.visible = false;
        }
      },
      (error: any): void => {}
    );
  }
}
